import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import TopView from '@max/leez-top-view';
import ModalBaseContainer from '@max/leez-modal-base-container';
import Button from '@hfe/max-button';
import './index.scss';
import ScrollView from '@hfe/max-scrollview';
function isShowLandMarkDetail(landmarkVO) {
    const cardExtra = landmarkVO?.cardExtra;
    return cardExtra && cardExtra?.landmarkImage && cardExtra?.landmarkName && cardExtra?.landmarkSlogan;
}
function LandmarkDetailPanel(props) {
    const { landmarkVO, children, onClose } = props;
    return <TopView>
      <ModalBaseContainer visible={props.visible} type="slide" onMaskPress={props.onClose} slideFrom="bottom" onOpened={props.onOpened} maskStyle={{
        opacity: 0.8
    }} maskAnimationIn={{
        opacity: [0, 0.8],
        duration: 300
    }} 
    // 设置蒙层出场动画结束后的透明度为 0
    maskAnimationOut={{
        opacity: [0.8, 0],
        duration: 300
    }}>
        <View className="landmark-detail-modal__wrapper">
          <Button className="landmark-detail-modal__close-button" onPress={() => {
        onClose();
    }}>
            <Image className="landmark-detail-modal__close-button-img" source={{
        uri: 'https://p0.meituan.net/ingee/dacb6cc62b5d35e0e749fc7a73bbe7821798.png'
    }}/>
          </Button>
          <View className="landmark-detail-modal__content-wrapper">
            <View x-if={isShowLandMarkDetail(landmarkVO)} className="landmark-detail-modal__header-wrapper">
              <Image source={{
        uri: landmarkVO?.cardExtra?.landmarkImage || ''
    }} className="landmark-detail-modal__header-img"/>
              <View className="landmark-detail-modal__header-content">
                <Text className="landmark-detail-modal__header-title-text" numberOfLines={1}>
                  {landmarkVO?.cardExtra?.landmarkName || ''}
                </Text>
                <Text className="landmark-detail-modal__header-desc-text" numberOfLines={3}>
                  {landmarkVO?.cardExtra?.landmarkSlogan || ''}
                </Text>
              </View>
            </View>
            <View className="landmark-detail-modal__scroll-view-outer-wrapper">
              <ScrollView showsVerticalScrollIndicator={false} style={{
        height: '988rpx'
    }} contentContainerStyle={{
        flexGrow: 1,
        flexShrink: 0,
        flexBasis: 'auto'
    }}>
                {children}
                <View className="landmark-detail-modal__footer"/>
              </ScrollView>
            </View>
          </View>
        </View>
      </ModalBaseContainer>
    </TopView>;
}
export default memo(LandmarkDetailPanel);
